import { httpsCallable } from 'firebase/functions';
import { functions } from '../config';
import type {
  TListManagedUsersResponse,
  TManagedUser,
  TSetUserRoleRequest,
  TSetUserRoleResponse,
} from './types';

const listManagedUsersCallable = httpsCallable<void, TListManagedUsersResponse>(
  functions,
  'listManagedUsers'
);

const setUserRoleCallable = httpsCallable<TSetUserRoleRequest, TSetUserRoleResponse>(
  functions,
  'setUserRole'
);

/** Fetch all users with their roles and login metadata (view-capable roles only). */
export async function listManagedUsers(): Promise<TManagedUser[]> {
  const result = await listManagedUsersCallable();
  return result.data.users;
}

/** Change a user's role (owners/administrators only). Returns the updated user. */
export async function setUserRole(request: TSetUserRoleRequest): Promise<TManagedUser> {
  const result = await setUserRoleCallable(request);
  return result.data.user;
}
